import { render, staticRenderFns } from "./zxconsultation.vue?vue&type=template&id=12252493&scoped=true&"
import script from "./zxconsultation.vue?vue&type=script&lang=js&"
export * from "./zxconsultation.vue?vue&type=script&lang=js&"
import style0 from "./zxconsultation.vue?vue&type=style&index=0&id=12252493&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12252493",
  null
  
)

export default component.exports